import React from 'react';
import { Checkbox } from '@trustpilot/businessapp-patternlibrary';

interface StarSelectorProps {
  includePreTaggedReviews: boolean;
  onChange: () => void;
}

const StarSelector = ({
  includePreTaggedReviews,
  onChange,
}: StarSelectorProps) => {
  return (
    <Checkbox checked={includePreTaggedReviews} onChange={onChange}>
      Include tags from your reviews on the Zendesk tickets
    </Checkbox>
  );
};

export default StarSelector;
